(ns frontend.view.nev.kyc.process.editor-utils
  (:require
   [common.schema.entities.workspace.kyc.kyc-utils :as ku]
   [common.util :as cu]))

(defn hide-question? [answers kyc-process question-meta]
  (let [cf (:conditional-field question-meta)
        hidden? (or (when (fn? cf)
                      (let [visible? (cf answers kyc-process)]
                        (not visible?)))
                    (= :role/system (some->> question-meta
                                             :field/default-authorization
                                             :access/write)))]
    hidden?))

(defn hide-section? [answers kyc-process section-meta]
  (let [condition-fn (:conditional-block section-meta)
        remove? (or (not (:questions section-meta))
                    (and condition-fn
                         (not (condition-fn answers kyc-process))))]
    remove?))

(defn mandatory? [_question-kw question-meta answers kyc-process]
  (let [{:keys [mandatory-field? conditional-field optional-field?]} question-meta]
    (and (if (fn? optional-field?)
           (not (optional-field? answers))
           (not optional-field?))
         (if (fn? mandatory-field?)
           (mandatory-field? answers kyc-process)
           mandatory-field?)
         (if (fn? conditional-field)
           (conditional-field answers kyc-process)
           (not conditional-field)))))

(defn list-field-items-missing-data?
  [{:keys [question-kw question-meta answers kyc-process
           missing-mandatory-value?]}]
  ;; TODO: Add more fields if needed
  (when (contains? #{:kyc-legal-entity/ubo-edn
                     :kyc-legal-entity/smo-edn
                     :kyc-tenant/ubo-edn
                     :kyc-person/ubo-edn
                     :contract-kyc/ubo-edn
                     :kyc-legal-entity/pep-edn
                     :kyc-person/pep-edn
                     :kyc-legal-entity/substantial-us-owners-edn
                     :kyc-legal-entity/controlling-persons-edn
                     :kyc-legal-entity/flow-through-ownership-jurisdictions}
                   question-kw)
    (let [template-schema (:data/template question-meta)
          non-optional-fields (->> template-schema
                                   (map second)
                                   (mapcat :questions)
                                   (remove (fn [[_field field-meta]]
                                             (:optional-field? field-meta))))
          items-missing-data?
          (some->> question-kw
                   (get answers)
                   (some (fn [item]
                           (->> non-optional-fields
                                (filterv (fn [[field field-meta]]
                                           (missing-mandatory-value? field field-meta item kyc-process)))
                                seq))))]
      items-missing-data?)))

(defn missing-mandatory-value? [question-kw question-meta answers kyc-process]
  (let [mandatory-field? (mandatory? question-kw question-meta answers kyc-process)
        field-visible? (if (fn? (:conditional-field question-meta))
                         ((:conditional-field question-meta) answers kyc-process)
                         true)
        value (get answers question-kw)
        too-few-items? (when-let [min-items (:min-items question-meta)]
                         (< (count value) min-items))
        confirm-field? (-> question-meta
                           :data/type
                           (= :data.type/confirm))
        deprecated-value? (ku/value-deprecated? (:options question-meta) value)
        missing-value? (and mandatory-field?
                            (or (cu/blank-value? value)
                                too-few-items?
                                deprecated-value?
                                (and confirm-field? (not value))))
        items-missing-data? (when field-visible?
                              (list-field-items-missing-data?
                               {:answers answers
                                :kyc-process kyc-process
                                :question-kw question-kw
                                :question-meta question-meta
                                :missing-mandatory-value? missing-mandatory-value?}))]
    (or missing-value?
        items-missing-data?)))

